import httpClient from "@/_shared/http-client";
import { usePagination } from "@/_shared/mixins/usePagination";
import { pagination } from "@/_shared/utils";

export const useModalSearch = {
  mixins: [usePagination],
  props: {
    joiningEntities: {
      type: Array,
      default() {
        return [];
      },
    },
    additionalFilters: {
      type: Array,
      default() {
        return [];
      },
    },
    preparingData: {
      type: Array,
      default: null,
    },
    linkSlug: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      list: [],
      searchData: "",
      searchWasApplied: false,
    };
  },
  async mounted() {
    await this.updateList();
  },
  methods: {
    async startSearch() {
      this.searchWasApplied = true;
      await this.updateList(1, this.searchData);
    },
    async dropSearch() {
      this.searchWasApplied = false;
      this.searchData = "";
      await this.updateList(1, []);
    },
    async changePage(value) {
      const usingData = this.searchWasApplied ? this.searchData : [];
      await this.updateList(value, usingData);
    },
    resetSearchForm() {
      this.searchData = "";
      this.searchWasApplied = false;
    },
    async updateList(page = 1, value = "") {
      this.isLoading = true;
      let url = `${process.env.BACKEND_URL}/records/${this.linkSlug}`;
      let params = `?page=${page}`;
      if (value) {
        params += `&filter=name,cs,${value}`;
      }
      if (Array.isArray(this.preparingData)) {
        const excludedRecordsIds = this.preparingData.map((value) => (
          value.id
        ));
        params += `&filter=id,nin,${excludedRecordsIds.join(',')}`;
      }
      this.additionalFilters.forEach((filter) => {
        const { field, predicate, value } = filter;
        params += `&filter=${field},${predicate},${value}`;
      });
      this.joiningEntities.forEach((joinName) => {
        params += `&join=${joinName}`;
      });
      url += params;
      httpClient.get(url).then((response) => {
        const { records, results } = response.data;
        this.list = records;
        this.usePagination(page, pagination.getPagesCounter(results));
        this.isLoading = false;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useModalSearch.js